import { DocumentCheckIcon } from '@heroicons/react/24/outline';
import { Switch } from '@main/complykit';
import { useUpdateOrganizationMutation } from '@main/graphql/mutations/UpdateOrganization.admin.generated';
import { useGetOrganizationQuery } from '@main/graphql/queries/GetOrganization.generated';
import { DrawerProperty } from '@main/ui';

import { useUpdateOrganizationHandler } from './use-update-org-handler';

export const VendorApprovalWorkflowsSwitch = ({ orgId }: { orgId: string }) => {
  const { data } = useGetOrganizationQuery({ orgId });
  const organization = data?.organizations_by_pk;
  const [updateOrganization, { isLoading }] = useUpdateOrganizationMutation();
  const updateOrgHandler = useUpdateOrganizationHandler(orgId);

  if (!organization) {
    return null;
  }

  return (
    <DrawerProperty>
      <DrawerProperty.Label
        icon={DocumentCheckIcon}
        id="vendor-approval-workflows-label"
        htmlFor="vendor-approval-workflows"
      >
        Vendor approval workflows
      </DrawerProperty.Label>
      <DrawerProperty.Content px={2} display="flex" alignItems="center">
        <Switch
          id="vendor-approval-workflows"
          aria-labelledby="vendor-approval-workflows-label"
          isSelected={organization.is_vendor_approval_workflows_enabled}
          isPending={isLoading}
          isDisabled={!organization.is_vendors_module_enabled}
          onChange={() => {
            updateOrgHandler(
              updateOrganization({
                organization_id: orgId,
                updatePayload: {
                  is_vendor_approval_workflows_enabled:
                    !organization.is_vendor_approval_workflows_enabled,
                },
              }),
            );
          }}
        />
      </DrawerProperty.Content>
    </DrawerProperty>
  );
};
